module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_4_04-d8e5b9ff03176bd29412c50df4141e83.jpg";